import React from 'react';
import { Mountain, Sun, Clock, MapPin } from 'lucide-react';

const iconMap = {
  mountain: Mountain,
  sun:      Sun,
  clock:    Clock,
  pin:      MapPin,
};

const InfoCard = ({ icon, label, value }) => {
  const Icon = iconMap[icon] || Mountain;

  return (
    <div className="pub-cus-des-info-card">
      <div className="pub-cus-des-info-icon">
        <Icon size={20} />
      </div>
      <div>
        <div className="pub-cus-des-info-label">{label}</div>
        <div className="pub-cus-des-info-value">{value}</div>
      </div>
    </div>
  );
};

export default InfoCard;